import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import { FormEvent, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import DateTableSelectedComunicados from "../../../components/dataTable/DataTableSelectedComunicados";
import { defineValueInInput } from "../../../components/funcForInput";
import getUrlSearchParams from "../../../components/funcGetUrlSearchParams";
import removeAllErrorMsg from "../../../components/funcRemoveAllErros";
import funcSleep from "../../../components/funcSleep";
import LoadingModal from "../../../components/loadingModal";
import { ApiEndpoints, reqGetNew, reqPatch, reqPostNew, reqPut } from "../../../config/apiClient";
import { getCookie } from "../../../config/cookies";
import ArquivoViewComunicado from "./ArquivoViewComunicado";
import RelatorioDados from "./RelatorioDados";

export default function ComunicadosFormPage() {
    useEffect(() => {
        document.title = "Cadastrar Comunicado | OB PORTUS";
        carregarDados();
        // eslint-disable-next-line
    }, []);
    const [comunicadoDados, setComunicadoDados] = useState<any>({});
    const [comunicadoPossuiImagem, setPossuiImagem] = useState<boolean>(false);
    const [comunicadoPossuiDocumento, setPossuiDocumento] = useState<boolean>(false);
    const [optionsColaboradores, setOptionsColaboradores] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [destinatariosSelecionados, setDestinatarios] = useState<any>({});

    // CARREGANDO DADOS
    async function carregarDados() {
        setLoading(true);
        const api = await reqGetNew(ApiEndpoints.comunicadosFiltros);
        if (api.status === 200) {
            setOptionsColaboradores(api.data);
            const url = getUrlSearchParams();
            const id_comunicado = url.get("id");
            if (id_comunicado !== null) {
                await getComunicadoDados(Number(id_comunicado), api.data);
            }
        }

        setLoading(false);
    }
    
    async function getComunicadoDados(id_comunicado: number, filtrosDados: any[]) {
        const data = { id: id_comunicado };
        const api = await reqPostNew(ApiEndpoints.comunicadoConsultar, data);
        if (api.status === 200) {
            setComunicadoDados(api.data);
            const dados = api.data;
            const comunicado = dados.comunicado;
            const documentos:any[] = dados.documentos;
            defineValueInInput("titulo", comunicado.titulo);
            defineValueInInput("mensagem", comunicado.mensagem);
            defineValueInInput("situacao", comunicado.situacao);
            if (comunicado.data_inicial !== null) {
                defineValueInInput("data_inicial", comunicado.data_inicial);
            }
            if (comunicado.data_final !== null) {
                defineValueInInput("data_final", comunicado.data_final);
            }

            const possui_imagem = comunicado.imagem !== null && comunicado.imagem_servidor !== null ? true : false
            setPossuiImagem(possui_imagem)
            const possui_documento = documentos.length > 0 ? true : false
            setPossuiDocumento(possui_documento)
            
            loadColaboradoresLista(dados.visualizacoes, filtrosDados);
        }
    }
    
    async function loadColaboradoresLista(views: any[], filtroDados: any[]) {
        if (views.length === 0) {
            return;
        }
        let linhasSelecionadas: any = {};
        for (let view of views) {
            if (view.acesso === 0) {
                continue;
            }
            const id_colaborador = view.id_colaborador;
            for (let idx = 0; idx < filtroDados.length; idx++) {
                const id = Number(filtroDados[idx].id_colaborador);
                if (id === id_colaborador) {
                    linhasSelecionadas[`${idx}`] = true;
                    break;
                }
            }
        }
        setDestinatarios(linhasSelecionadas);
    }
    
    async function handleUpdateComunicado() {
        if (Object.values(comunicadoDados).length === 0) { return }
        const id_comunicado = comunicadoDados.comunicado.id_comunicado
        await getComunicadoDados(id_comunicado, optionsColaboradores)
    }
    
    // VALIDAÇÃO DOS DADOS
    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        event.stopPropagation();
        removeAllErrorMsg();

        const form: any = event.target;
        let formValidado = true;
        let dados = {
            id_comunicado: Object.values(comunicadoDados).length === 0 ? null : comunicadoDados.comunicado.id_comunicado,
            titulo: form.titulo.value,
            data_inicial: form.data_inicial.value,
            data_final: form.data_final.value,
            mensagem: form.mensagem.value,
            situacao: Number(form.situacao.value),
            ids_colaboradores: getIdsColaboradores(),
        };
        console.log(dados);

        if (dados.titulo === "") {
            form.titulo.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.mensagem === "") {
            form.mensagem.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.data_inicial === "") {
            dados.data_inicial = null;
        } else {
            if (dados.data_inicial.length > 0 && dados.data_inicial.length !== 16) {
                form.data_inicial.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.data_inicial.length === 16) { dados.data_inicial = dayjs(dados.data_inicial).format("YYYY-MM-DD HH:mm:ss"); }
        }
        if (dados.data_final === "") {
            dados.data_final = null;
        } else {
            if (dados.data_final.length > 0 && dados.data_final.length !== 16) {
                form.data_final.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.data_final.length === 16) { dados.data_final = dayjs(dados.data_final).format("YYYY-MM-DD HH:mm:ss"); }
        }
        if (dados.ids_colaboradores.length === 0) {
            toast.warning("Necessário selecionar ao menos 1 destinatário!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            formValidado = false;
        }

        if (!formValidado) {
            return;
        }
        const arquivos = {
            imagem: form.imagem.files,
            documento: form.documento.files,
        }
        if (dados.id_comunicado === null) {
            cadastrar(dados, arquivos.imagem, arquivos.documento);
        }
        if (dados.id_comunicado > 0) {
            editar(dados, arquivos.imagem, arquivos.documento);
        }
    }
    
    function getIdsColaboradores(): number[] {
        let ids_colaboradores: number[] = [];
        for (let idx in destinatariosSelecionados) {
            for (let index = 0; index < optionsColaboradores.length; index++) {
                const id = Number(optionsColaboradores[index].id_colaborador);
                if (index === Number(idx)) {
                    ids_colaboradores.push(id);
                    break;
                }
            }
        }
        console.log(`selecionados`);
        console.log(ids_colaboradores);
        return ids_colaboradores;
    }
    
    function handleSelecionarTodos() {
        let destinatarios: any = {};
        for (let idx = 0; idx < optionsColaboradores.length; idx++) {
            destinatarios[`${idx}`] = true;
        }
        setDestinatarios(destinatarios);
    }

    // ENVIANDO DADOS PARA API
    async function cadastrar(dados: any, imagem: any[], documento: any[]) {
        setLoading(true);
        const api = await reqPut(ApiEndpoints.comunicadoCadastrar, dados);
        if (api.status === 201) {
            const comunicado = api.data.comunicado
            const id_comunicado = comunicado.id_comunicado
            if (documento.length > 0) {
                const arquivo = documento[0]
                await enviarDocumento(id_comunicado, arquivo)
            }
            if (imagem.length > 0) {
                const arquivo = imagem[0]
                await enviarImagemDestaque(id_comunicado, arquivo)
            }
            toast.success("Comunicado cadastrado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/comunicado/editar?id=${id_comunicado}`);
        } else { 
            setLoading(false);
        }
    }
    
    async function editar(dados: any, imagem: any[], documento: any[]) {
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.comunicadoEditar, dados);
        if (api.status === 200) {
            const id_comunicado = dados.id_comunicado
            if (documento.length > 0) { 
                const arquivo = documento[0]
                await enviarDocumento(id_comunicado, arquivo)
            }
            if (imagem.length > 0) { 
                const arquivo = imagem[0]
                await enviarImagemDestaque(id_comunicado, arquivo)
            }
            toast.success("Comunicado editado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            handleUpdateComunicado()
            // await funcSleep(600);
            // window.location.assign(`/comunicados`);
        }
        setLoading(false);
    }

    async function enviarArquivo(endpoint: string, dados: FormData):Promise<any> {
        const token = getCookie("token");
        const id_usuario = getCookie("id_user");
        try {
            let api: Response;
            let apiData = await fetch(endpoint, {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${token}`,
                    id_usuario: id_usuario,
                },
                body: dados,
            }).then((response) => {
                api = response;
                return response.json();
            });
            if (api!.status === 200) {
                return {
                    status: api!.status,
                    message: String(apiData.message),
                }
            } else {
                return {
                    status: api!.status,
                    message: String(apiData.message),
                }
            }
        } catch (error) {
            console.log(error);
            return {
                status: 0,
                message: "Não foi possível enviar o arquivo, tente novamente mais tarde ou contate o suporte!",
            }
        }
    }
    
    async function enviarDocumento(id_comunicado: number, arquivo: any) { 
        let dados = new FormData();
        dados.append("id_comunicado", id_comunicado.toString());
        dados.append("documento", arquivo);
        await enviarArquivo(ApiEndpoints.comunicadoEnviarDocumento.endpoint, dados)
    }
    async function enviarImagemDestaque(id_comunicado: number, arquivo: any) { 
        let dados = new FormData();
        dados.append("id_comunicado", id_comunicado.toString());
        dados.append("imagem_destaque", arquivo);
        await enviarArquivo(ApiEndpoints.comunicadoEnviarImagemDestaque.endpoint, dados)
    }
    
    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={() => {}} />
            <div className="div-row-space-between">
                {Object.values(comunicadoDados).length === 0 && <h1 id="titleMain">Cadastrar Comunicado</h1>}
                {Object.values(comunicadoDados).length > 0 && <h1 id="titleMain">Editar Comunicado</h1>}
                <Button
                    onClick={() => {
                        window.location.assign(`/comunicados`);
                    }}
                    variant="secondary"
                >
                    Voltar
                </Button>
            </div>
            <br></br>
            <Form id="formComunicados" onSubmit={handleSubmit} style={{ position: "relative" }} noValidate>
                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Título:</Form.Label>
                            <Form.Control name="titulo" type="text" id="titulo" placeholder="Título do Comunicado" />
                            <Form.Control.Feedback type="invalid">Informe o Título do Comunicado!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Data Inicial:</Form.Label>
                            <Form.Control name="data_inicial" type="datetime-local" id="data_inicial" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe uma data válida!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Data Final:</Form.Label>
                            <Form.Control name="data_final" type="datetime-local" id="data_final" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe uma data válida!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Mensagem do Comunicado:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={1000} name="mensagem" id="mensagem" autoComplete="off" />
                            <Form.Control.Feedback type="invalid">Escreva a mensagem aqui!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-6">
                        <Row>
                            <Col className="col-6">
                                <Form.Group>
                                    <Form.Label>Imagem de Destaque (.jpg ou .png):</Form.Label>
                                    <Form.Control style={{display: comunicadoPossuiImagem ? "none" : "block"}} type="file" name="imagem" id="imagem" aria-label="Selecione o arquivo" accept="image/png, image/jpeg" />
                                    <Form.Control.Feedback type="invalid">Selecione o arquivo!</Form.Control.Feedback>
                                </Form.Group>
                                {Object.values(comunicadoDados).length > 0 && <ArquivoViewComunicado view={"imagem"} comunicado={comunicadoDados.comunicado} documentos={comunicadoDados.documentos} handleUpdate={()=>handleUpdateComunicado()} />}
                                <br></br>
                                <Form.Group>
                                    <Form.Label>Situação:</Form.Label>
                                    <Form.Select name="situacao" id="situacao" aria-label="Selecione a opção">
                                        <option value="1">Ativo</option>
                                        <option value="0">Inativo</option>
                                    </Form.Select>
                                </Form.Group>
                                <br></br>
                                <Button type="submit" variant="success" style={{ marginRight: "10px" }}>
                                    Salvar Comunicado
                                </Button>
                            </Col>
                            <Col className="col-6">
                                <Form.Group>
                                    <Form.Label>Documentos (.jpg, .png, .docx, .pdf):</Form.Label>
                                    <Form.Control style={{display: comunicadoPossuiDocumento ? "none" : "block"}} type="file" name="documento" id="documento" aria-label="Selecione o arquivo" accept=".docx, .pdf" />
                                    <Form.Control.Feedback type="invalid">Selecione o arquivo!</Form.Control.Feedback>
                                </Form.Group>
                                {Object.values(comunicadoDados).length > 0 && <ArquivoViewComunicado view={"documento"} comunicado={comunicadoDados.comunicado} documentos={comunicadoDados.documentos} handleUpdate={()=>handleUpdateComunicado()} />}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {Object.values(comunicadoDados).length > 0 && <RelatorioDados comunicado={comunicadoDados.comunicado} relatorio={comunicadoDados.relatorio} views={comunicadoDados.visualizacoes} />}
                <br></br>
                <div>
                    <h2 style={{ fontSize: "1.4em", fontWeight: "bold" }}>Definir Destinatários</h2>
                    <br></br>
                    <div className="div-row">
                        <p style={{ marginRight: "10px" }}>Selecionados: {Object.values(destinatariosSelecionados).length}</p>
                        <Button onClick={() => handleSelecionarTodos()} variant="secondary" style={{ marginRight: "10px" }}>
                            Selecionar todos
                        </Button>
                        <Button onClick={() => setDestinatarios({})} variant="secondary" style={{ marginRight: "10px" }}>
                            Remover Selecionados
                        </Button>
                    </div>
                    <br></br>
                    <DateTableSelectedComunicados dados={optionsColaboradores} tableSize={"auto"} defaultColumns={defaultColumns} defaultOrder={defaultOrder} rowSelection={destinatariosSelecionados} handleSetRowSelection={(data: any) => setDestinatarios(data)} />
                </div>
            </Form>
        </div>
    );
}

const columnHelper = createColumnHelper<any>();

const defaultColumns = [
    columnHelper.accessor((row) => "", {
        id: "select",
        header: ({ table }) => <input type="checkbox" checked={table.getIsAllRowsSelected()} onChange={table.getToggleAllRowsSelectedHandler()} />,
        cell: ({ row }) => <input type="checkbox" checked={row.getIsSelected()} disabled={!row.getCanSelect()} onChange={row.getToggleSelectedHandler()} />,
        size: 10,
        enableSorting: false,
    }),
    columnHelper.accessor((row) => `${row.matricula} - ${row.nome_completo}`, {
        header: "Colaborador",
    }),
    columnHelper.accessor("empresa", {
        header: "Empresa",
    }),
    columnHelper.accessor("centro_custo", {
        header: "Centro de Custo",
    }),
    columnHelper.accessor("cargo", {
        header: "Cargo",
    }),
    columnHelper.accessor((row) => `${row.situacao} AD-${dayjs(row.data_admissao).format("DD/MM/YYYY")} ${String(row.data_demissao).length !== 10 ? "" : `DM-${dayjs(row.data_demissao).format("DD/MM/YYYY")}`}`, {
        header: "Situação",
        id: "situacao",
    }),
];

const defaultOrder: any[] = [];
